module.exports = __webpack_public_path__ + "static/media/raiffeisen.d5781d90.png";